import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import { LazyLoadedImage } from './LazyLoadedImage';
const Image = ({ alt, decoding = 'async', lazyLoad = true, onError, onLoad, src, ...restImageProps }) => {
    const imageRef = useRef(null);
    // fix onload is not fired on client hydratation https://github.com/facebook/react/issues/15446
    useEffect(() => {
        if (onLoad && !lazyLoad && imageRef.current?.complete) {
            onLoad();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return lazyLoad ? (_jsx(LazyLoadedImage, { alt: alt, src: src, onLoad: onLoad, onError: onError, decoding: decoding, ...restImageProps })) : (_jsx("img", { alt: alt, decoding: decoding, src: src, ref: imageRef, onLoad: onLoad, onError: onError, ...restImageProps }));
};
export { Image };
